import { View, Text } from "reshaped";
import { useResponsiveClientValue } from "../../hooks";
import { CertificateItem } from "./CertificateItem/CertificateItem";
import { CertificatesProps } from "./Certificates.types";

export const Certificates = (props: CertificatesProps) => {
  const { list } = props;

  const responsiveColumns: any | undefined = useResponsiveClientValue({
    s: 12,
    l: 4,
  });

  return (
    <View gap={5}>
      <Text variant="featured-1" weight="bold">
        Certificados
      </Text>

      <View gap={5} direction="row">
        {list?.map((item) => {
          return (
            <View.Item key={item.id} columns={responsiveColumns}>
              <CertificateItem list={item} />
            </View.Item>
          );
        })}
      </View>
    </View>
  );
};
